module.exports = __webpack_public_path__ + "img/join-discord.f97b9b62.png";